import { render, staticRenderFns } from "./CashDesk.vue?vue&type=template&id=23b489c8&scoped=true"
import script from "./CashDesk.vue?vue&type=script&lang=js"
export * from "./CashDesk.vue?vue&type=script&lang=js"
import style0 from "./CashDesk.vue?vue&type=style&index=0&id=23b489c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b489c8",
  null
  
)

export default component.exports